import { type ModuleRoutes } from '@core/declarations/router'

const Agenda = () => import('@dashboard/modules/Bookings/views/Agenda.vue')
const Calendar = () => import('@dashboard/modules/Bookings/views/Calendar.vue')
const Availability = () => import('@dashboard/modules/Bookings/views/Availability.vue')
const PricingPolicies = () => import('@dashboard/modules/Bookings/views/PricingPolicies.vue')
const LinkGroups = () => import('@dashboard/modules/Bookings/views/LinkGroups.vue')
const ConnectedCalendars = () => import('@dashboard/modules/Bookings/views/ConnectedCalendars.vue')
const BookingStatus = () => import('@dashboard/modules/Bookings/views/BookingStatus/BookingStatus.vue')
const BookingUnsuccessful = () => import('@dashboard/modules/Bookings/views/BookingUnsuccessful/BookingUnsuccessful.vue')

// ***
// DASHBOARD ROUTES
// ***
export const managerBooking = [{
  name: 'managerBooking',
  path: '/:clubHash/bookings',
  children: [
    {
      path: 'agenda',
      name: 'managerBookingAgenda',
      component: Agenda,
      meta: {
        tabTitle: 'Agenda',
      },
    },
    {
      path: 'calendars',
      name: 'managerBookingCalendars',
      component: Calendar,
      meta: {
        tabTitle: 'Booking calendars',
      },
    },
    {
      path: 'availability',
      name: 'managerBookingAvailability',
      component: Availability,
      meta: {
        tabTitle: 'Availability',
      },
    },
    {
      path: 'connected-calendars',
      name: 'managerConnectedCalendars',
      component: ConnectedCalendars,
      meta: {
        tabTitle: 'Connected calendars',
      },
    },
    {
      path: 'pricing-policies',
      name: 'managerBookingPricingPolicies',
      component: PricingPolicies,
      meta: {
        tabTitle: 'Pricing policies',
      },
    },
    {
      path: 'link-groups',
      name: 'managerBookingLinkGroups',
      component: LinkGroups,
      meta: {
        tabTitle: 'Link groups',
      },
    },
  ],
}]

// ***
// PUBLIC ROUTES
// ***

export const bookingRoutes : ModuleRoutes = {
  name: 'Bookings',
  basePath: '/bookings',
  routes: [{
    path: '/:bookingHash',
    name: 'bookingSuccess',
    component: BookingStatus,
    meta: {
      navigationType: 'clean',
      tabTitle: 'Booking status',
    },
  },
  {
    path: '/:bookingHash/unsuccessful',
    name: 'bookingUnsuccessful',
    component: BookingUnsuccessful,
    meta: {
      navigationType: 'clean',
      tabTitle: 'Booking failed',
    },
  }],
}
